import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  mainContainer: {paddingBottom: 10, paddingTop: 20, paddingHorizontal: 20},
  imageVanStyle: {
    height: 69,
    width: 114,
    marginTop: -10,
  },
});
